"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var build_1 = require("@ori-events/loyalty-dialog-result/build");
exports.LastAddedItemMethod = build_1.Result;
exports.Name = "basket-updated";
exports.BasketUpdatedEvent = exports.Name;
